export var Ordering;
(function (Ordering) {
    Ordering["Unordered"] = "unordered";
    Ordering["Ordered"] = "ordered";
})(Ordering || (Ordering = {}));
//# sourceMappingURL=IList.js.map